/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ApiService extends __BaseService {
  static readonly jsJsFilepathPath = '/js/{filepath}';
  static readonly swaggerSwaggerJsonPath = '/swagger.json';
  static readonly swaggerUiSwaggerFilepathPath = '/swagger/{filepath}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Download goa/js
   * @param filepath Relative file path
   * @return File downloaded
   */
  jsJsFilepathResponse(filepath: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/js/${encodeURIComponent(String(filepath))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Download goa/js
   * @param filepath Relative file path
   * @return File downloaded
   */
  jsJsFilepath(filepath: string): __Observable<Blob> {
    return this.jsJsFilepathResponse(filepath).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Download internal/goa/swagger/swagger.json
   * @return File downloaded
   */
  swaggerSwaggerJsonResponse(): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/swagger.json`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Download internal/goa/swagger/swagger.json
   * @return File downloaded
   */
  swaggerSwaggerJson(): __Observable<Blob> {
    return this.swaggerSwaggerJsonResponse().pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * Download internal/goa/swagger/
   * @param filepath Relative file path
   * @return File downloaded
   */
  swaggerUiSwaggerFilepathResponse(filepath: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/swagger/${encodeURIComponent(String(filepath))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * Download internal/goa/swagger/
   * @param filepath Relative file path
   * @return File downloaded
   */
  swaggerUiSwaggerFilepath(filepath: string): __Observable<Blob> {
    return this.swaggerUiSwaggerFilepathResponse(filepath).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module ApiService {
}

export { ApiService }
